import { MessageGetter } from 'react-message-context';
import { PictogramName } from '../../components/common/Pictogram';
import { ThemeColor } from '../../theme/theme';
import { NoticeFormType, PublicNotice } from '../../types/notices';
import { Folder2, MFilesLink } from '../../context/kennoTenantContext';

export const NOTICE_PAGE_QUERY_PARAM = 'p';

export const getPictogramForNoticeType = (noticeType: NoticeFormType | 'document'): PictogramName => {
  switch (noticeType) {
    case NoticeFormType.ActionReport:
    case NoticeFormType.ActionPlan:
      return 'book';
    case NoticeFormType.MeetingMinutes:
      return 'notepad';
    case 'document':
      return 'pdf';
  }
};
export const getBackgroundForNoticeType = (noticeType: NoticeFormType | Folder2): ThemeColor => {
  switch (noticeType) {
    case NoticeFormType.ActionReport:
      return 'apila';
    case NoticeFormType.ActionPlan:
      return 'strawberry';
    case NoticeFormType.MeetingMinutes:
      return 'lemon';
    case 'Kodinkoneet':
    case 'Tietoa asumisesta':
    case 'TV- ja tietoliikenne':
    case 'Kodinhoito ja -huolto':
    case 'Turvallisuus':
    case 'Lämmitys ja ilmanvaihto':
      return 'apila';
  }
};

export const getNoticeDisplayTitle = (notice: PublicNotice | MFilesLink, t: MessageGetter): string => {
  switch (notice.formType) {
    case NoticeFormType.MeetingMinutes:
      return notice.formData.name;
    case NoticeFormType.ActionPlan:
      return t('actionPlan.title', { year: notice.formData.year });
    case NoticeFormType.ActionReport:
      return t('actionReport.title', { year: notice.formData.year });
    case 'document':
      return `${t('title')} - ${notice.Folder2}`;
    default:
      return '';
  }
};
